<div class="logo-cropper" #cropperWrap>
    <img-cropper #cropper [image]="imageData" (onCrop)="cropped($event)" [settings]="cropperSettings"></img-cropper>

    <div class="m-t-2">
        <p>Preview:</p>
        <img #preview [src]="imageData.image" alt="Please select an image from the above box" [width]="previewWidth"
            [height]="previewHeight" style="object-fit: contain">
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/image.cropper/image.cropper.component.html